module.exports = __webpack_public_path__ + "img/sale1.f4ad1f42.png";